/**
 * Curated OpenMoji subset (CC-BY-SA-4.0) — committed under
 * `public/assets/icons/`. The colour SVGs come from
 * https://github.com/hfg-gmuend/openmoji.
 *
 * Two pools live here:
 *  - `MODE_ICONS`     — one icon per game-mode tile on the home screen.
 *  - `TRIAL_ICONS`    — the rotating set used by counting / addition /
 *                       subtraction sessions (one icon picked per session
 *                       and applied to every trial in that session).
 *
 * Codepoint → file: OpenMoji file names are uppercase hex with hyphens.
 * Multi-codepoint emoji (like the keycap-1) keep their full sequence.
 */

export interface IconAsset {
  /** Stable id used in code. */
  id: string;
  /** OpenMoji codepoint(s); also the SVG filename without `.svg`. */
  codepoint: string;
  /** Friendly English name (used for screen-readers / parent debugging). */
  labelEn: string;
  /** Friendly Dutch name. */
  labelNl: string;
}

function asset(id: string, codepoint: string, labelEn: string, labelNl: string): IconAsset {
  return { id, codepoint, labelEn, labelNl };
}

export function iconUrl(icon: IconAsset): string {
  return `/assets/icons/${icon.codepoint}.svg`;
}

export const MODE_ICONS = {
  recognize: asset('mode.recognize', '0031-FE0F-20E3', 'one (keycap)', 'één (keycap)'),
  count: asset('mode.count', '1F34E', 'red apple', 'rode appel'),
  add: asset('mode.add', '2795', 'plus', 'plus'),
  sub: asset('mode.sub', '2796', 'minus', 'min'),
} as const;

export const TRIAL_ICONS: readonly IconAsset[] = [
  asset('apple', '1F34E', 'apple', 'appel'),
  asset('duck', '1F986', 'duck', 'eend'),
  asset('cat', '1F408', 'cat', 'kat'),
  asset('dog', '1F415', 'dog', 'hond'),
  asset('fish', '1F420', 'fish', 'vis'),
  asset('star', '2B50', 'star', 'ster'),
  asset('strawberry', '1F353', 'strawberry', 'aardbei'),
  asset('balloon', '1F388', 'balloon', 'ballon'),
  asset('sunflower', '1F33B', 'sunflower', 'zonnebloem'),
];
